const COLOR_ORDINAL = [
    "#8260C5",
    "#DAACFF",
    "#442278",
    "#604AAF",
    "#E179A5",
    "#FFBAE0",
    "#64253F",
    "#AD4470",
    "#74A9FF",
    "#CEE1FF",
    "#0B2B60",
    "#1457C5",
    "#C6A57A",
    "#EEDFCA",
    "#3A2B16",
    "#634B2B",
    "#F4C343",
    "#FFF5DD",
    "#785F20",
    "#BC9736",
    "#51B2BA",
    "#D6FCFF",
    "#174043",
    "#225B5F",
    "#2FC172",
    "#B1FFD5",
    "#082917",
    "#0D5A30",
    "#000000",
    "#AFAFAF",
    "#505050",
    "#F1F1F1"

]


export default COLOR_ORDINAL;